import { api } from './client';
import type {
  SubscriptionStatusResponse,
  UsageQuota,
  VerifyPurchaseRequest,
} from '@affogato/shared';

// Response types
interface StatusResponse {
  data: SubscriptionStatusResponse;
}

interface UsageResponse {
  data: UsageQuota;
}

interface VerifyResponse {
  success: boolean;
  subscription?: unknown;
  message: string;
}

// Subscription API
export const subscriptionApi = {
  /**
   * Get subscription status including plan, limits, and usage
   */
  getStatus: () => api.get<StatusResponse>('/subscription/status'),

  /**
   * Get current month's usage quota
   */
  getUsage: () => api.get<UsageResponse>('/subscription/usage'),

  /**
   * Verify a Google Play purchase
   * Used by mobile app to validate subscription
   */
  verifyPurchase: (data: VerifyPurchaseRequest) =>
    api.post<VerifyResponse>('/subscription/verify', data),
};
